import { createSelector } from "reselect";

/**
 * selector to determine if in progress evaluations csv export is enabled
 */
export const inProgressEvaluationsCsvExportEnabledSelector = createSelector(
  () => true
);
